'use client'; 

import React from 'react';
import { Link } from '@/lib/target';
import { usePathname } from '@/lib/target'; 
import { BREADCRUMB } from '@/contants';

const BreadcrumbStanding = ({ className }) => {
  const pathname = usePathname();
  const pathArray = pathname.split('/').filter((path) => path);

  const breadcrumbs = pathArray.map((path, index) => {
    const breadcrumbPath = `/${pathArray.slice(0, index + 1).join('/')}`;    
    const label = BREADCRUMB.find((item) => item.slug == path)?.name;
    
    return {
      label: label || path, 
      path: breadcrumbPath,
    };
  });

  return (
    <nav className={className} aria-label="Breadcrumb">
      <ol className="inline-flex items-center space-x-1 @md:space-x-3">
        <li className='inline-flex items-center'>
          <Link href="/" className="text-gray-700 dark:text-breadcrumb-dark hover:text-blue-600">
            Trang chủ
          </Link>
          <svg
            className="w-4 h-4 text-gray-400 mx-1"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            ></path>
          </svg>
        </li>
        {breadcrumbs.map((breadcrumb, index) => (
          <li key={index} className="inline-flex items-center">
            {index !== breadcrumbs.length - 1 ? (
              <Link href={breadcrumb.path} className="text-gray-700 dark:text-breadcrumb-dark hover:text-blue-600">
                {breadcrumb.label}
              </Link>
            ) : (
              <span className=" font-semibold">{breadcrumb.label}</span>
            )}
            {index !== breadcrumbs.length - 1 && (
              <svg
                className="w-4 h-4 text-gray-400 mx-1"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clipRule="evenodd"
                ></path>
              </svg>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default BreadcrumbStanding;
